module.exports = __webpack_public_path__ + "static/img/h3-13.0b93ba8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner1/h3-13.png
// module id = SdBR
// module chunks = 1